// components
export const copyToClipboard = async text => {
    try {
        if (!navigator.clipboard) throw new Error();

        await navigator.clipboard.writeText(text);

        return true;
    } catch (error) {
        console.error("Unable to copy attribution text to clipboard");
        return false;
    }
};

// ICONSHARE: Differences? May need to raise up to consumer
export const getButtonText = (isCopied, isDesktop, attributionButtonText) => {
    const { copied, desktop, modal } = attributionButtonText;
    return isCopied ? copied : isDesktop ? desktop : modal;
};
